import { render, staticRenderFns } from "./MspAttivitaNuoto.vue?vue&type=template&id=9a38feea"
import script from "./MspAttivitaNuoto.vue?vue&type=script&lang=js"
export * from "./MspAttivitaNuoto.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports